window.config = {
  servers: {
    // default: 'https://zhaopinhr-uat.feser.com.cn'
    default: 'https://foryouhr.fesco.com.cn'
  },
  // tenementId: 'e83f1ec3f1064387b15d146f8400cce4'
  tenementId: 'd7985617779442b589c47c35e959cec7'
}



// WEBPACK FOOTER //
// ./src/conf/config.js